export const quickdashEs = {
  questions: [
    {
      promInstructions:
        "Por favor califica tu capacidad para hacer las siguientes actividades en la última semana:",
      scaleStartLabel: "Sin Dificultad",
      scaleEndLabel: "Incapaz",
      scaleLabels: [
        "Sin Dificultad",
        "Dificultad Leve",
        "Dificultad Moderada",
        "Dificultad Severa",
        "Incapaz",
      ],
      text: "Abrir un frasco apretado o nuevo",
    },
    {
      promInstructions:
        "Por favor califica tu capacidad para hacer las siguientes actividades en la última semana:",
      scaleStartLabel: "Sin Dificultad",
      scaleEndLabel: "Incapaz",
      scaleLabels: [
        "Sin Dificultad",
        "Dificultad Leve",
        "Dificultad Moderada",
        "Dificultad Severa",
        "Incapaz",
      ],
      text: "Hacer tareas domésticas pesadas (ej., lavar paredes, pisos)",
    },
    {
      promInstructions:
        "Por favor califica tu capacidad para hacer las siguientes actividades en la última semana:",
      scaleStartLabel: "Sin Dificultad",
      scaleEndLabel: "Incapaz",
      scaleLabels: [
        "Sin Dificultad",
        "Dificultad Leve",
        "Dificultad Moderada",
        "Dificultad Severa",
        "Incapaz",
      ],
      text: "Llevar una bolsa de compras o maletín",
    },
    {
      promInstructions:
        "Por favor califica tu capacidad para hacer las siguientes actividades en la última semana:",
      scaleStartLabel: "Sin Dificultad",
      scaleEndLabel: "Incapaz",
      scaleLabels: [
        "Sin Dificultad",
        "Dificultad Leve",
        "Dificultad Moderada",
        "Dificultad Severa",
        "Incapaz",
      ],
      text: "Lavarte la espalda",
    },
    {
      promInstructions:
        "Por favor califica tu capacidad para hacer las siguientes actividades en la última semana:",
      scaleStartLabel: "Sin Dificultad",
      scaleEndLabel: "Incapaz",
      scaleLabels: [
        "Sin Dificultad",
        "Dificultad Leve",
        "Dificultad Moderada",
        "Dificultad Severa",
        "Incapaz",
      ],
      text: "Usar un cuchillo para cortar comida",
    },
    {
      promInstructions:
        "Por favor califica tu capacidad para hacer las siguientes actividades en la última semana:",
      scaleStartLabel: "Sin Dificultad",
      scaleEndLabel: "Incapaz",
      scaleLabels: [
        "Sin Dificultad",
        "Dificultad Leve",
        "Dificultad Moderada",
        "Dificultad Severa",
        "Incapaz",
      ],
      text: "Actividades recreativas en las que recibes alguna fuerza o impacto a través de tu brazo, hombro o mano. (ej., golf, martillar, tenis, etc.)",
    },
    {
      promInstructions: "Durante la semana pasada:",
      scaleStartLabel: "Nada",
      scaleEndLabel: "Extremo",
      scaleLabels: [
        "Nada en Absoluto",
        "Ligeramente",
        "Moderadamente",
        "Bastante",
        "Extremadamente",
      ],
      text: "¿En qué medida tu problema de brazo, hombro o mano ha interferido con tus actividades sociales normales con familia, amigos, vecinos o grupos?",
    },
    {
      promInstructions: "Durante la semana pasada:",
      scaleStartLabel: "Sin Límite",
      scaleEndLabel: "Incapaz",
      scaleLabels: [
        "No limitado en absoluto",
        "Ligeramente limitado",
        "Moderadamente limitado",
        "Muy limitado",
        "Incapaz",
      ],
      text: "¿Estuviste limitado en tu trabajo u otras actividades diarias regulares como resultado de tu problema de brazo, hombro o mano?",
    },
    {
      promInstructions:
        "Por favor califica la severidad de los síntomas en la última semana:",
      scaleStartLabel: "Ninguno",
      scaleEndLabel: "Extremo",
      scaleLabels: ["Ninguno", "Leve", "Moderado", "Severo", "Extremo"],
      text: "Dolor en brazo, hombro o mano",
    },
    {
      promInstructions:
        "Por favor califica la severidad de los síntomas en la última semana:",
      scaleStartLabel: "Ninguno",
      scaleEndLabel: "Extremo",
      scaleLabels: ["Ninguno", "Leve", "Moderado", "Severo", "Extremo"],
      text: "Hormigueo (agujas y alfileres) en tu brazo, hombro o mano",
    },
    {
      promInstructions: "Durante la semana pasada:",
      scaleStartLabel: "Sin Dificultad",
      scaleEndLabel: "No Puede Dormir",
      scaleLabels: [
        "Sin Dificultad",
        "Dificultad Leve",
        "Dificultad Moderada",
        "Dificultad Severa",
        "Tanta dificultad que no puedo dormir",
      ],
      text: "¿Cuánta dificultad has tenido para dormir debido al dolor en tu brazo, hombro o mano?",
    },
  ],
};
